module.exports = __webpack_public_path__ + "img/frame_3.2350454.webp";